// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar__x8Az5"};